import { useState } from 'react';
import { ProviderProductApi } from '@recargas-dominicanas/core/api';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { TextField } from '@recargas-dominicanas/core/components';
import { Modal } from '../../../../components/modal/modal.component';
import { ProductSelect } from '../../../../components/product-select/product-select.component';
import { ProviderStore } from '../../../../store/providerStore';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { style } from './add-product-modal.module.css';

interface Props {
  open: boolean;
  providerId: number;
  onClose: () => void;
}

export function AddProductModal(props: Props) {

  const { open, providerId, onClose } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    product: { value: undefined as IProduct | undefined },
    profit: '',
    key: ''
  });

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await ProviderProductApi.add({ 
        key: form.key.value,
        profit: parseFloat(form.profit.value),
        productId: form.product.value!.id,
        providerId: providerId
      });

      await ProviderStore.fetchProducts(providerId);

      handleClose();

    } catch {

      setError('Error guardando producto');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Agregar producto'
      style={style.modal}
      secondaryButton='Agregar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <ProductSelect
        className={style.select}
        label='Producto'
        placeholder='Seleccionar producto'
        value={form.product.value}
        error={form.product.error}
        onChange={form.product.onChange}/>
      <TextField 
        style={style.textField}
        label='Beneficio'
        type='number'
        value={form.profit.value}
        error={form.profit.error}
        onChange={form.profit.onChange}
        onBlur={form.profit.onBlur}/>
      <TextField 
        style={style.textField}
        label='Clave'
        value={form.key.value}
        error={form.key.error}
        onChange={form.key.onChange}
        onBlur={form.key.onBlur}
        onEnter={handleSave}/>
    </Modal>
  );
}
